export default __webpack_public_path__ + "static/media/etj.bf12fca4.jfif";